import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { globTabsSelector } from "../VisualBuilder/components/GlobalTabs/GlobalTabsDataSlice";
import { ACTION, ENTITY } from "../constants";
import { getCurrentExperiences } from "../store/actions";

export function useCurrentExperiencesData(props) {
  const { propertyId, userId, hookEnabled } = props;

  const dispatch = useDispatch();
  const timer = useRef({});

  const { experienceIds = [] } = useSelector(globTabsSelector(propertyId, userId));

  const fetchExperiences = (experienceId) => {
    if (timer.current[experienceId]) {
      clearTimeout(timer.current[experienceId]);
    }

    timer.current[experienceId] = setTimeout(() => {
      dispatch(getCurrentExperiences(propertyId, experienceId));
    }, 300);
  };

  useEffect(() => {
    if (experienceIds.length && hookEnabled) {
      const listener = ({ detail }) => {
        const { entity, action, instances = [] } = detail;

        let changedExperiences = [];
        if (
          entity === ENTITY.EXPERIENCE &&
          [ACTION.UPDATED, ACTION.BULK_UPDATED, ACTION.DELETED, ACTION.BULK_DELETED].includes(action)
        ) {
          changedExperiences = changedExperiences.concat(instances);
        }

        if (changedExperiences.length) {
          experienceIds.forEach((experienceId) => {
            if (changedExperiences.includes(experienceId)) {
              fetchExperiences(experienceId);
            }
          });
        }
      };

      const entities = [ENTITY.EXPERIENCE];

      entities.forEach((entity) => document.addEventListener(entity, listener));

      return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
    }
  }, [propertyId, experienceIds.length]);
}
